import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * GlobalPropertiesProcessor формирует свойства для каждой выбранной директории (за исключением вариантов)
 */
export class GlobalPropertiesProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const properties = Object.values(additionalServiceState.ServicesPath)
      .map((s) => s.properties)
      .flat(1)
      .sort((a, b) => {
        if (a.ordinal === b.ordinal) {
          return a.id < b.id ? 1 : -1;
        }

        return a.ordinal < b.ordinal ? 1 : -1;
      });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        PropertiesToDisplay: properties,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
